module.exports = require("./ky.d.ts");